import React from 'react';
import TransactionsLink from 'components/Links/TransactionsLink';
import Dropdown from 'components/UIKit/Dropdown';

let TransactionTypeFilter = ({
  isDryRun,
  type,
  query,
  state,
  style,
}) => {
  return (
    <span style={style}>
      <span>Step: &nbsp;</span>
      <Dropdown selected={isDryRun === 'true' ? 'Validate' : isDryRun === 'false' ? 'Commit' : 'All'}>
        <TransactionsLink query={{ state, type, ...query, offset: 0 }}>
          All
        </TransactionsLink>
        <TransactionsLink
          query={isDryRun !== 'true' ? { ...query, state, type, isDryRun: true, offset: 0 } : { ...query, state, type }}
        >
          Validate
        </TransactionsLink>
        <TransactionsLink
          query={isDryRun !== 'false' ? { ...query, state, type, isDryRun: false, offset: 0 } : { ...query, state, type }}
        >
          Commit
        </TransactionsLink>
      </Dropdown>
    </span>
  );
};

export default TransactionTypeFilter;
